<dls-headline #headLineReference dlsRightSideNav [title]="headline" [id]="sectionFragmentID" [level]="1"
    [offset]="0" class="d-flex align-items-center" *ngIf="headline" (mouseenter)="isMouseOver = true"
    (mouseleave)="isMouseOver = false">
    <span class="me-2">
        {{headline}}
    </span>
    <button atlas-icon-button (click)="copyLink()" class="align-middle" aria-label="Share Link">
        <mat-icon [ngClass]="{'visible': isMouseOver || isFocus, 'invisible': !isMouseOver && !isFocus}">link
        </mat-icon>
    </button>
</dls-headline>
<ng-content></ng-content>